/*
 * Copyright (c) 2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      19 February 2024
 */

interface Props {
  video?: string;
}

const VideoContainer = ({ video }: Props) => {
  return (
    <div className='aspect-w-16 aspect-h-9'>
      <iframe
        src={video}
        frameBorder='0'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
      ></iframe>
    </div>
  );
};
export default VideoContainer;
